import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute7  from '../../app/routes/PrivateRoute7'

import AccountPreferences from './AccountPreferences'

const EndUserPreferencesRoutes = () => {
  return (
    <Routes>
        <Route path="/" element={<PrivateRoute7><AccountPreferences /></PrivateRoute7>} />
        <Route path="preferences" element={<PrivateRoute7><AccountPreferences /></PrivateRoute7>} />
        {/*<Route path="edit-user" element={<PrivateRoute7><EditUsers /></PrivateRoute7>} />
        <Route path="new-user" element={<PrivateRoute7><NewUsers /></PrivateRoute7>} />*/}
    </Routes>
  )
}

export default EndUserPreferencesRoutes